export default __webpack_public_path__ + "i18n/translation-zh.40f29e7b.json";